import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const projectList = (params = '') => Http.get(`/admin/projects${serialize(params)}`)
export const projectCreate = (params = '') => Http.post('/admin/projects', params)
export const projectByID = (params = '') => Http.get(`/admin/projects/${params}`)
export const projectUpdate = (params = '') => Http.put(`/admin/projects/${params.id}`, params)
export const projectDestroy = (params = '') => Http.delete(`/admin/projects/${params.id}`)
